export const GLUCOSE_CUSTOM_ORDERING: string[] = [
	'blood_glucose',
	'blood_glucose_fasting',
	'blood_glucose_before_breakfast',
	'blood_glucose_after_breakfast',
	'blood_glucose_before_lunch',
	'blood_glucose_after_lunch',
	'blood_glucose_before_dinner',
	'blood_glucose_after_dinner',
	'blood_glucose_before_sleep',
	'blood_glucose_3am',
	'blood_glucose_before_workout',
	'blood_glucose_extra',
];
